import React from 'react';
import { mockData } from '../utils/mockData';
export const PerformanceView = () => {
  const {
    summary,
    recentContributions
  } = mockData.performance;
  return <div className="space-y-6" data-id="element-141">
      <div className="space-y-4" data-id="element-142">
        <h3 className="text-lg font-semibold" data-id="element-143">Performance Summary</h3>
        <p className="text-sm text-[#e0e0e0] leading-relaxed" data-id="element-144">{summary}</p>
      </div>
      <div className="space-y-4" data-id="element-145">
        <h3 className="text-sm font-semibold text-[#888888] uppercase" data-id="element-146">
          Recent Contributions
        </h3>
        <div className="space-y-3" data-id="element-147">
          {recentContributions.map((item, index) => <div key={index} className="flex items-center justify-between p-3 bg-[#2a2a2a] rounded-lg" data-id="element-148">
              <div data-id="element-149">
                <p className="text-sm font-medium" data-id="element-150">{item.action}</p>
                <p className="text-xs text-[#888888]" data-id="element-151">{item.date}</p>
              </div>
              <span className="text-sm font-medium text-[#4a90e2]" data-id="element-152">
                {item.points}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};